// GET /project?organisationId=<id></id>

import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getProjectsList = async (id, page, entriesPerPage) => {
    const url = `${BASE_URL}/project?organisationId=${id}&fetchEntryCount=false&page=${page}&entriesPerPage=${entriesPerPage}`;
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getProjectsListCount = async (id) => {
    try {
        const url = `${BASE_URL}/project?organisationId=${id}&fetchEntryCount=true`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
